import React from 'react';
import { SearchFileIcon, PenIcon, DeleteIcon } from '@src/svg';
import { idType } from '@src/types';
import { ModalType } from '@uikit/Modal/modals/constants';

export const buildButtonsDropdownOptions = ({
  rowId,
  buttons,
  abilities,
  modalName,
  tableName,
  openModal,
  onEditClick,
  onAuditClick,
  handleSelectedRow,
  setSelectedItem,
  handleDeleteRow,
}: {
  rowId: idType;
  buttons?: { view: boolean; edit: boolean; audit: boolean; delete?: boolean };
  abilities?: string[];
  modalName?: string;
  tableName?: string;
  openModal?: (name: string, id: idType) => void;
  onEditClick?: (id: idType) => void;
  onAuditClick?: (id: idType, type: ModalType, name?: string) => void;
  handleSelectedRow?: (id: idType) => void;
  setSelectedItem: (id: idType) => void;
  handleDeleteRow?: (id: idType) => void;
}) => [
  ...(abilities?.includes('Edit') && buttons?.edit
    ? [
        {
          item: (
            <>
              <PenIcon width={16} height={16} /> Edit
            </>
          ),
          closeWhenClicked: true,
          onSelect: () => {
            openModal?.(modalName!, rowId);
            onEditClick?.(rowId);
            handleSelectedRow && setSelectedItem(rowId);
          },
        },
      ]
    : []),
  ...(abilities?.includes('Audit') && buttons?.audit
    ? [
        {
          item: (
            <>
              <SearchFileIcon width={16} height={16} /> Audit
            </>
          ),
          closeWhenClicked: true,
          onSelect: () => onAuditClick?.(rowId, 'auditLog', tableName),
        },
      ]
    : []),
  ...(abilities?.includes('Delete') && buttons?.delete
    ? [
        {
          item: (
            <>
              <DeleteIcon width={16} height={16} /> Delete
            </>
          ),
          closeWhenClicked: true,
          onSelect: () => handleDeleteRow?.(rowId),
        },
      ]
    : []),
];

export const buildStatusDropdownOptions = ({
  id,
  value,
  statusSetter,
}: {
  id: idType;
  value: boolean;
  statusSetter?: (id: idType, status: boolean) => void;
}) => [
  {
    item: <div className="status_item">Active</div>,
    closeWhenClicked: true,
    onSelect: () => statusSetter && !value && statusSetter(id, true),
  },
  {
    item: <div className="status_item">Inactive</div>,
    closeWhenClicked: true,
    onSelect: () => statusSetter && value && statusSetter(id, false),
  },
];
